import { environment } from 'src/environments/environment';
import { EnvironmentService } from 'src/app/common/services/environment.service';

/**
 * Here we can define the common constants within the project.
 * We will be able to use them in any component, and make the change
 * in only one place in case we have to change the value of these.
 */
var env: string;
var isProd: boolean;

export const environments = setEnv();

/**
 * `environments` as `{ label, value }` options for multi-selects (with optionLabel="label"
 * optionValue="value", so the bound value stays a string array). A PrimeNG multi-select filters
 * options by their label field, so plain string options never matched its search box (CMS-6337).
 */
export const environmentOptions: ReadonlyArray<{ label: string; value: string }> =
    environments.map((env) => ({ label: env, value: env }));

/**
 * Sets the list of environments by url.
 */
function setEnv()
{

    let envs: Array<string> = [];
    let env = EnvironmentService.getEnvironmentName();

    switch (env)
    {
        case 'local':
            envs = ['dev', 'test', 'qa', 'prod'];
            break;
        case 'development':
            envs = ['dev', 'qa', 'prod'];
            break;
        case 'test':
            envs = ['test'];
            break;
        case 'production':
            envs = ['dev', 'qa', 'prod'];
            break;
    }
    return envs;
}
